import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme';
import { Heading } from '@weave/design-system';
import { InsurancePayerMixTotalAppointment } from './insurance-payer-mix-total-appointment';
import { PayerMixSummary as PayerMixSummaryType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';
import { InsurancePayerMixWebCoverage } from './insurace-payer-mix-total-web-coverage';
import { InsurancePayerMixPotentialCoverage } from './insurance-payer-mix-potential-web-coverage';
import { InsurancePayerMixRecommendedGain } from './insurance-payer-mix-recommended-gain';
import { ChurnRiskLevel } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { InsurancePayerMixChurnRisk } from './insurance-payer-mix-churn-risk';

type PayerMixSummaryProps = {
  summary?: PayerMixSummaryType;
  isEnhancedEligibilityCustomizationEnabled?: boolean;
};

export const PayerMixSummary = ({
  summary,
  isEnhancedEligibilityCustomizationEnabled,
}: PayerMixSummaryProps) => {
  if (!summary) {
    return null;
  }

  return (
    <>
      <div css={payerMixSummaryStyles}>
        <InsurancePayerMixChurnRisk
          churnRisk={
            isEnhancedEligibilityCustomizationEnabled
              ? summary?.churnRiskLevel ?? ChurnRiskLevel.CHURN_RISK_LEVEL_UNSPECIFIED
              : undefined
          }
        />

        <InsurancePayerMixWebCoverage
          currentWebCoveragePercentage={summary?.currentWebCoveragePercentage ?? 0}
        />
        <InsurancePayerMixPotentialCoverage
          potentialWebCoveragePercentage={summary?.potentialWebCoveragePercentage ?? 0}
        />
        <InsurancePayerMixRecommendedGain
          recommendedGainPercentage={summary?.recommendedConnectionsGainPercentage ?? 0}
        />
        <InsurancePayerMixTotalAppointment totalCount={summary?.totalAppointments ?? 0} />
      </div>
      {summary?.projectedCoverageAfterRecommendationsPercentage && (
        <Heading
          level={3}
          css={{ margin: theme.spacing(3, 0, 0, 0) }}
        >{`Projected Web Coverage after recommended connection ${summary?.projectedCoverageAfterRecommendationsPercentage}%`}</Heading>
      )}
    </>
  );
};

const payerMixSummaryStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
});
